import React from 'react';
import { FaTwitter, FaInstagram, FaFacebookF, FaLinkedinIn } from "react-icons/fa";

import { useSelector } from 'react-redux';



const FooterTwo = () => {
    const appUI = useSelector(state => state.appUI);
    const SocialShare = [
        { Social: <FaFacebookF />, link: appUI.realEstateAgentTexts.personal.socials.fb },
        { Social: <FaLinkedinIn />, link: appUI.realEstateAgentTexts.personal.socials.linkedIn },
        { Social: <FaInstagram />, link: appUI.realEstateAgentTexts.personal.socials.ig },
        { Social: <FaTwitter />, link: appUI.realEstateAgentTexts.personal.socials.twitter },
    ]
    return (
        <div className="footer-style-2 ptb--30 bg_image bg_image--1" data-black-overlay="6">
            <div className="wrapper plr--50 plr_sm--20">
                <div className="row align-items-center justify-content-between">
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                        {appUI.realEstateAgentTexts.personal.name.includes("Zikmunda") ? null :
                            <div className="inner">
                                <div className="logo text-center text-sm-left mb_sm--20">
                                    <a href="https://www.p4l-group.cz/" target="_blank">
                                        <img src={appUI.realEstateAgentTexts.personal.homePage.img.footerImage} style={{ width: '300px' }} alt="P4L-RK" />
                                    </a>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                        <div className="inner text-center">
                            <ul className="social-share rn-lg-size d-flex justify-content-center liststyle">
                                {SocialShare.map((val, i) => (
                                    !val.link.endsWith('/') ? <li key={i}><a href={`${val.link}`} target="_blank">{val.Social}</a></li> : null
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                        <div className="inner text-lg-right text-center mt_md--20 mt_sm--20">
                            <div className="text">
                                <p>{appUI.realEstateAgentTexts.personal.name.includes("Zikmunda") ? `© ${new Date().getFullYear()} Tomáš Zikmunda` : appUI.realEstateAgentTexts.common.homePage.footerCopyright}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FooterTwo;
